import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxPowerBiModule } from 'ngx-powerbi';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedUIModule } from '../shared/shared-ui.module';
import { ChangeViewerRoutes } from './change-viewer.routes';
import { ChangeViewerComponent } from './change-viewer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RegulationService } from 'src/app/core/services/regulation';
import { GDPRService } from 'src/app/core/services/rulebook/gdpr.service';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { CommonService } from './../../core/services/common/common.service';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { DistributedUIModule } from '../distributed-ui-components/distributed-ui.module';
import { RegulatoryDashboardComponent } from './regulatory-dashboard/regulatory-dashboard.component';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { ChangeViewerLandingComponent } from './change-viewer-landing/change-viewer-landing.component';
import { ManualUpdateModule } from '../manual-update/manual-update.module';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { TrendingTopicsDashboardComponent } from './trending-topics-dashboard/trending-topics-dashboard.component';
import { AngularD3CloudModule } from 'angular-d3-cloud'
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { DatePipe} from '@angular/common';
import { RegulationDescriptionComponent } from './regulation-description/regulation-description.component';
import { TooltipModule } from 'primeng/tooltip';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LucideAngularModule,Languages,SquarePen, ArrowRightToLine } from 'lucide-angular';


@NgModule({
  declarations: [
    ChangeViewerLandingComponent,
    ChangeViewerComponent,
    RegulatoryDashboardComponent,
    TrendingTopicsDashboardComponent,
    RegulationDescriptionComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule.forRoot(),
    RouterModule.forChild(ChangeViewerRoutes),
    CdkTreeModule,
    MatDialogModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDatepickerModule,
    DistributedUIModule,
    MatChipsModule,
    BsDropdownModule,
    SharedUIModule,
    ScrollingModule,
    NgxPowerBiModule,
    ManualUpdateModule,
    MatBadgeModule,
    AngularD3CloudModule,
    NgApexchartsModule,
    MatTooltipModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    MatPaginatorModule,
    TooltipModule,
    InlineSVGModule,
    LucideAngularModule.pick({Languages, SquarePen, ArrowRightToLine})
  ],
  providers: [
    RegulationService,
    AnalyticsService,
    SessionService,
    GDPRService,
    CommonService,
    UserManagementService,
    DatePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ChangeViewerModule { }
